import React from 'react';
import PropTypes from 'prop-types';
import IntlMessages from 'util/IntlMessages';
import PlaceholderSpinner from 'components/kea/placeholders/PlaceholderSpinner';
import { Link } from 'react-router-dom';
import { Button, Paper } from '@material-ui/core';
import PlaceholderError from '../placeholders/PlaceholderError';
import styles from './CardContainerSmall.module.scss';

const CardContainerSmall = ({
  error,
  children,
  isFetching,
  headerId,
  showMoreUrl,
  height,
  tone,
}) => (
  <Paper elevation={0} className={`${styles.card} ${styles[tone] || ''}`}>
    <header className={styles.header}>
      <h3><IntlMessages id={headerId} /></h3>
    </header>
    {isFetching || error
      ? <StubComponent error={error} height={height} isFetching={isFetching} />
      : <div className={styles.body}>{children}</div>}
    {showMoreUrl && (
      <div className={styles.action}>
        <Button component={Link} to={showMoreUrl} size="small">
          <IntlMessages id="common.showMore" />
        </Button>
      </div>
    )}
  </Paper>
);

const StubComponent = ({ error, isFetching, height }) => {
  if (isFetching) return <PlaceholderSpinner height={height} />;
  return <PlaceholderError error={error} height={height} />;
};

CardContainerSmall.defaultProps = {
  children: null,
  headerId: null,
  isFetching: false,
  height: 268,
  error: null,
  showMoreUrl: null,
  tone: 'searches',
};

CardContainerSmall.propTypes = {
  children: PropTypes.node,
  headerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  isFetching: PropTypes.bool,
  height: PropTypes.number,
  error: PropTypes.any,
  showMoreUrl: PropTypes.string,
  tone: PropTypes.oneOf([
    'searches',
    'clickRate',
    'zeroResults',
    'clickEvents',
    'productViews',
    'lostOpportunities',
  ]),
};

export default CardContainerSmall;
